import http from '~/http/index';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        createdFrom: filters.createdFrom && (Date.parse(`${filters.createdFrom}T00:00:00.000Z`) / 1000),
        createdTo: filters.createdTo && (Date.parse(`${filters.createdTo}T23:59:59.000Z`) / 1000),
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('v2/Marketplace/inventory', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;

      const users = new Set();
      items.forEach((e) => users.add(e.merchantId));
      const responseUsers = await http.post('User/GetUsers', {
        userIdList: Array.from(users),
      });
      items.forEach((e) => {
        e.merchantName = responseUsers.data?.items?.find((user) => user.id === e.merchantId)?.userName;
      });

      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async editProduct(__store, data) {
      const response = await http.put('v2/Marketplace/inventory', data);
      return response.data;
    },
  },

  namespaced: true,
});
